import { Delivery as DeliveryBase } from "@omni/components/components/Product/ECommerce/components/delivery/delivery";

import { DeliveryComponent } from "@/components/Product/ECommerce/components/delivery/delivery.component";

export const Delivery = () => {
    return (
        <DeliveryBase>
            <DeliveryComponent />
        </DeliveryBase>
    );
};
